import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import GloballyFreeSubscriptionPlan from './globally-free-subscription-plan';
import GloballyFreeSubscriptionPlanDetail from './globally-free-subscription-plan-detail';
import GloballyFreeSubscriptionPlanUpdate from './globally-free-subscription-plan-update';
import GloballyFreeSubscriptionPlanDeleteDialog from './globally-free-subscription-plan-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={GloballyFreeSubscriptionPlanUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={GloballyFreeSubscriptionPlanUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={GloballyFreeSubscriptionPlanDetail} />
      <ErrorBoundaryRoute path={match.url} component={GloballyFreeSubscriptionPlan} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={GloballyFreeSubscriptionPlanDeleteDialog} />
  </>
);

export default Routes;
